/* eslint-disable react/no-children-prop */
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import List from "app/pages/.shared/List.jsx";
import Separator from "app/pages/.shared/Separator";
import "./PriceDetails.scss";

const PriceDetailsMobile = ({ children, included, notIncluded }) => {
	return (
		<div className="price-detail">
			<div className="price-detail__list">
				<Separator design="middle" />

				<div className="included">
					<div className="included__list">
						<div className="included__title">
							<FormattedMessage id="price.detail.included.title" /> :
						</div>
						<List items={included} enableHTMLFormatting={true} />
					</div>
					<div className="included__list">
						<div className="included__title">
							<FormattedMessage id="price.detail.not.included.title" /> :
						</div>
						<List items={notIncluded} enableHTMLFormatting={true} />
					</div>
				</div>
				{children}
			</div>
		</div>
	);
};

PriceDetailsMobile.propTypes = {
	included: PropTypes.arrayOf(PropTypes.string),
	notIncluded: PropTypes.arrayOf(PropTypes.string),
	partialPayment: PropTypes.shape({
		dueDate: PropTypes.number,
		payNowAmount: PropTypes.number,
		payLaterAmount: PropTypes.number,
	}),
};

export default PriceDetailsMobile;
